<template>
  <div class="page page--fill">
    <data-list
      v-if="$env.billing"
      title="Articles"
      client="billing"
      resource="items"
      :columns="columns">
      <template #actions>
        <v-btn
          color="primary"
          depressed
          :to="{ name: 'newBillsItem' }">
          <v-icon
            left
            small>
            mdi-plus
          </v-icon>
          Nouvel article
        </v-btn>
      </template>
      <template #code="{ item }">
        <span class="cell-mono">{{ item.code }}</span>
      </template>
      <template #row_actions="{ item }">
        <v-btn
          icon
          small
          title="Modifier"
          @click.stop="editItem(item)">
          <v-icon small>
            mdi-pencil-outline
          </v-icon>
        </v-btn>
      </template>
    </data-list>
    <billing-unavailable v-else />
  </div>
</template>

<script>
  import DataList from '../components/DataList'
  import BillingUnavailable from '../components/BillingUnavailable'
  import { formatPrice } from '../labels'

  export default {
    name: 'BillsItems',
    components: { DataList, BillingUnavailable },
    data () {
      return {
        columns: [
          { key: 'code', label: 'Code', width: 160 },
          { key: 'name', label: 'Article' },
          { key: 'price', label: 'Prix', width: 140, align: 'end', format: formatPrice },
          { key: 'row_actions', label: '', width: 60, align: 'end' }
        ]
      }
    },
    methods: {
      editItem (item) {
        this.$router.push({ name: 'editBillsItem', params: { source: item } })
      }
    }
  }
</script>
